<template>
  <div class="com-table balance border infoListWrap">
    <div class="com-title pr">招商智投（普投）-信息流</div>
    <div class="ms-list">
      <el-row class="operation">
        <el-button-group>
          <el-button type="primary" size="small" :data="search.list" @click="download"><icon name="cloud-download"/>导出</el-button>
        </el-button-group>
      </el-row>
      <div ref="msSearch"><ms-search :data="search.list" @click="updateConditions"/></div>
      <div class="table-learn" v-if="table.list.length !== 0">
        <el-button size="small" type="danger" @click="deleteList()">批量删除</el-button>
        <el-button size="small" type="primary" @click="changeRead(1)">批量已读</el-button>
        <el-button size="small" type="primary" @click="changeRead(0)">批量未读</el-button>
        <el-button size="small" type="primary" @click="distributeAll()">批量手动分配</el-button>
      </div>
      <el-table
        v-loading="table.loading"
        size="small" stripe
        :data="this.table.list"
        :fit="true"
        @selection-change="handleSelectionChange">
        <template slot="empty">
          <no-data></no-data>
        </template>
        <el-table-column type="selection" width="45"></el-table-column>
        <el-table-column label="" min-width="60" fixed>
          <template slot-scope="scope">
            <span>
                <i class="el-icon-delete" @click="deletes(scope.$index)"></i>
              </span>
              <span class="isRead">
                <template v-if="scope.row.readStatus === 0">
                  <i class="el-icon-s-comment" title="标为已读" @click="read(scope.$index, 1)"></i>
                  <i class="unRead-icon"></i>
                </template>
                <template v-else>
                  <i class="el-icon-s-comment" title="标为未读" @click="read(scope.$index, 0)"></i>
                </template>
              </span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="feedbackId" label="ID" min-width="60" fixed="left"></el-table-column> -->
        <el-table-column prop="itemTitle" label="项目名称" min-width="170">
          <template slot-scope="scope">
            <!-- <template v-if="scope.row.readStatus === 0">
              <i class="unRead-icon"></i>
            </template> -->
            {{scope.row.itemTitle}}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="channelTitle" label="平台名称" min-width="120"></el-table-column> -->
        <el-table-column prop="name" label="姓名" min-width="80"></el-table-column>
        <el-table-column prop="phone" label="手机号码" width="110"></el-table-column>
        <el-table-column prop="region" label="地域" min-width="120"></el-table-column>
        <!-- <el-table-column prop="data" label="详细信息" min-width="180">
          <template slot-scope="scope">
            <div v-for="(value,key) in scope.row.datas">
              <span>{{key}}：{{value}}</span>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column prop="descrip" label="画像" min-width="100"></el-table-column>
        <el-table-column prop="otherInfo" label="其他信息" min-width="140"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="140"></el-table-column>
        <el-table-column prop="crmFollower" label="接收人" min-width="80"></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="140">
          <template slot-scope="scope">
            <span>{{scope.row.remark}}</span>
            <span @click="popUs(scope.$index)" style="cursor: pointer">
              <icon name="pencil-square-o"></icon>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="落地页" min-width="100" v-if="showPageUrl">
          <template slot-scope="scope">
            <a class="pageUrl" :href="scope.row.pageUrl" target="_blank">{{scope.row.pageUrl}}</a>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="70">
          <template slot-scope="scope">
            <template v-if="scope.row.crmFollower.length  > 0 || scope.row.remark.indexOf('与crm资源重复')>-1">
              已分配
            </template>
            <template v-else><el-button type="text" size="small" @click="distribution(scope.$index)">手动分配</el-button></template>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="table.pagination.page"
        :total="table.pagination.totalRow"
        :page-size="table.pagination.pageSize"
        :page-sizes="table.pagination.pageSizes"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange">
      </el-pagination>
      <!--修改备注-->
      <el-dialog title="修改" :visible.sync="dialogVisible" width="30%" top="15%" center :before-close="handleClose">
        <el-input type="textarea" :rows="10" v-model="message.remark" placeholder="请输入内容"></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="modifierRemrak">提 交</el-button>
        </span>
      </el-dialog>
      <!--手动分配-->
      <el-dialog center align = "center" :visible.sync="dialogFpVisible" width="40%" :close-on-click-modal="false">
        <p style="text-align:center;">
          接收人：
          <el-select v-model="distribute.id" filterable remote placeholder="请输入话务人员姓名" :remote-method="remoteMethod" :loading="loading" style="width:50%">
            <template v-if="channelSource === 2">
              <el-option v-for="item in userList" :key="item.id" :label="item.sourceName" :value="item.sourceId" ></el-option>
            </template>
            <el-option v-for="item in userList" :key="item.id" :label="item.userName" :value="item.id" v-else></el-option>
          </el-select>
        </p>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" :disabled="loading" @click="saveDistribute">确 定</el-button>
          <el-button @click="dialogFpVisible = false">取 消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>

</template>

<script>
  import MsDetailShow from '@/components/common/FeedbackList'
  import MsSearch from '@/components/common/Search.vue'
  import MsConfirmButton from '@/components/common/ConfirmButton.vue'
  import Api from '@/api/feedback'
  import ResponseParse from '@/utils/response-parse'
  import { FORM_LIST_SEARCH_CONDITION } from '@/models/feedbacks'
  import moment from 'moment'

  export default {
    components: {
      MsDetailShow,
      MsSearch,
      MsConfirmButton
    },
    data () {
      return {
        userInfo: {},
        showPageUrl: false,
        dialogVisible: false,
        resourceList: [],
        search: {
          list: [],
          condition: {}
        },
        dialogFpVisible: false,
        distribute: {},
        userList: [],
        table: {
          loading: true,
          list: [],
          pagination: {}
        },
        message: {
          index: 0,
          id: 0,
          platform: '',
          remark: ''
        },
        chooseArrCustomer: [],
        chooseArrToday: [],
        channelSource: 1 // 2:按客人来源 1:按员工来源(默认)
      }
    },
    created () {
      this.userInfo = JSON.parse(sessionStorage.getItem('user'))
      let date = []
      date[0] = moment().subtract(0, 'days').format('YYYY-MM-DD')
      date[1] = moment().subtract(0, 'days').format('YYYY-MM-DD')
      this.search.condition.startTime = date[0]
      this.search.condition.endTime = date[1]
      this.table.list = []
      this.search.list = FORM_LIST_SEARCH_CONDITION
      this.search.list[0].value = date
      Api.itemTitle({search: {modeType: 1}}, response => {
        let itemTitle = response.data.data
        let title = []
        itemTitle.forEach(value => {
          title.push({value: value.title, label: value.title})
        })
        this.search.list[1].config.list = title
      })
      this.requestList()
      this.getChannerSource()
    },
    methods: {
      async getChannerSource () {
        let response = await Api.getCrmAssignResourceType()
        let status = response.status || 0
        let body = response.data || {}
        if (status >= 200 || status <= 204) {
          this.channelSource = body.assignResourceType
        }
      },
      handleSelectionChange (val) {
        this.chooseArrCustomer = val
        this.resourceList = val.map(im => {
          return {id: im.feedbackId, taleName: im.tableName}
        })
      },
      popUs (index) {
        this.dialogVisible = true
        this.message.index = index
        const item = this.table.list[index]
        this.message.tableName = item.tableName
        this.message.remark = item.remark
        this.message.id = this.table.list[index].feedbackId
      },
      modifierRemrak () {
        Api.modifyRemark({id: this.message.id, remark: this.message.remark, tableName: this.message.tableName}, response => {
          let status = response.status || 0
          if (status >= 200 && status <= 204) {
            let data = this.table.list[this.message.index]
            data.remark = this.message.remark
            this.table.list.splice(this.message.index, 1, data)
            this.dialogVisible = false
            this.$message.success('修改成功')
          } else {
            this.$message.error('修改失败')
          }
        })
      },
      remoteMethod (query) {
        let search = {}
        search.userName = query
        let ApiName = 'likeness'
        if (this.channelSource === 2) {
          ApiName = 'speLikeness'
          search.userName = ''
          search.sourceName = query
        }
        Api[ApiName]({search: search}, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status >= 200 && status <= 204) {
            this.userList = body
          }
        })
      },
      thridPush () {
        this.$confirm('确定操作？', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '分配中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          Api.assignResourcesManuallyByThridPush({form: this.distribute}, response => {
            loading.close()
            let status = response.status || 0
            let body = response.data || []
            if (status >= 200 && status <= 204) {
              this.$message.success(body.submitResult ? '操作成功：' + body.submitResult : '分配成功')
              this.requestList()
            } else {
              this.$message.error(body.error ? '操作失败：' + body.error : '分配失败')
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
      },
      distribution (index) {
        const item = this.table.list[index]
        let form = {}
        form.id = item.feedbackId
        form.taleName = item.tableName
        this.distribute.resourceList = [form]
        if (this.channelSource === 3) {
          this.thridPush()
        } else {
          this.dialogFpVisible = true
        }
      },
      saveDistribute () {
        this.loading = true
        let ApiName = 'distribute'
        if (this.channelSource === 2) {
          ApiName = 'speDistribute'
          this.distribute.channelSourceCode = this.distribute.id
        } else {
          this.distribute.userId = this.distribute.id
        }
        Api[ApiName]({form: this.distribute}, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status >= 200 && status <= 204) {
            this.dialogFpVisible = false
            this.$message.success(body.submitResult ? '操作成功：' + body.submitResult : '分配成功')
            this.requestList()
          } else {
            this.$message.error(body.error ? '操作失败：' + body.error : '分配失败')
          }
          this.loading = false
        })
      },
      deleteList () {
        this.$confirm('确定删除?', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(() => {
          if (this.chooseArrCustomer.length > 0) {
            let form = this.chooseArrCustomer.map(item => {
              return {feedbackId: item.feedbackId, tableName: item.tableName}
            })
            Api.resourceBatchDelete(form, () => {})
            this.chooseArrCustomer = []
            setTimeout(() => {
              this.requestList()
            }, 500)
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      distributeAll () {
        if (this.resourceList.length === 0) {
          this.$message.error('请先选择列表数据！')
          return
        }
        this.distribute.resourceList = this.resourceList
        if (this.channelSource === 3) {
          this.thridPush()
        } else {
          this.dialogFpVisible = true
        }
      },
      changeRead (type) {
        // type:0 批量未读type:1 批量已读
        if (this.chooseArrCustomer.length === 0) {
          this.$message.error('请先选择列表数据！')
          return
        }
        let form = {type: type}
        form.datas = this.chooseArrCustomer.map(item => {
          return {feedbackId: item.feedbackId, tableName: item.tableName}
        })
        Api.updateBatchReadStatus(form, response => {
          let status = response.status || 0
          let body = response.data || {}
          if (status >= 200 && status <= 204) {
            const data = body.list
            this.changeList(data)
          } else {
            this.$message.error(body.error || '操作失败')
          }
        })
      },
      changeList (data) {
        this.table.list.forEach(item => {
          data.forEach(item1 => {
            if (item.feedbackId === item1.id) {
              item.readStatus = item1.readStatus
              // this.$set(item, 'readStatus', item1.readStatus)
            }
          })
        })
      },
      deletes (index) {
        const item = this.table.list[index]
        this.$confirm('确定删除?', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(() => {
          Api.resouceDelete({feedbackId: item.feedbackId, tableName: item.tableName}, response => {
            let status = response.status || 0
            let body = response.data || {}
            if (status >= 200 && status <= 204) {
              this.table.list.splice(index, 1, Object.assign({}, item, {status: -1}))
            } else {
              this.$message.error(body.error || '操作失败')
            }
            this.requestList()
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      read (index, type) {
        // type 0: 未读 1:已读
        let item = this.table.list[index]
        Api.updateReadStatus({feedbackId: item.feedbackId, tableName: item.tableName, type}, response => {
          let status = response.status
          if (status >= 200 && status <= 204) {
            item.readStatus = Number(!item.readStatus)
              // 将原值替换为修改后的值
            this.table.list.splice(index, 1, item)
          }
        })
      },
      requestList () {
        this.table.loading = true
        const search = Object.assign({}, this.table.pagination, this.search.condition)
        Api.formList({search: search}, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            this.table.list = body
            let list = []
            this.table.list.forEach(item => {
              if (item.data !== undefined && item.data !== '') {
                let d = JSON.parse(item.data)
                if (d !== null) {
                  item.datas = d
                } else {
                  item.datas = []
                }
              } else {
                item.datas = []
              }
              list.push(item)
            })
            this.table.list = list
            if (this.table.list[0].showPageUrl) {
              this.showPageUrl = true
            } else {
              this.showPageUrl = false
            }
            this.table.pagination = ResponseParse.pagination(response.headers)
          } else {
            this.showPageUrl = false
            this.table.list = []
          }
          this.table.loading = false
        })
      },
      handleSizeChange (val) {
        this.table.pagination.pageSize = val
        this.requestList()
      },
      handleCurrentChange (val) {
        this.table.pagination.page = val
        this.requestList()
      },
      updateConditions (conditions) {
        this.table.pagination.page = 1
        let time = conditions.time || []
        this.search.condition = Object.assign({}, conditions, {startTime: time[0], endTime: time[1]})
        this.requestList()
      },
      download (conditions) {
        let search = ''
        let flag = true
        this.search.list.forEach(item => {
          let text = item.name
          let value = item.value
          if (item.type === 'select') {
            if (item.hasOwnProperty('config') && item.config.hasOwnProperty('list')) {
              item.config.list.forEach(function (option) {
                if (option.label === item.value) {
                  value = option.value
                }
              })
            }
          }
          if (search === '') {
            if (text === 'time' && value !== '') {
              if (value === null) {
                this.$message({
                  type: 'error',
                  message: '请选择时间范围'
                })
                flag = false
              }
              search = '?startTime=' + value[0] + '&endTime=' + value[1]
            } else {
              if (value !== null && value !== '' && value !== undefined) {
                search = '?' + text + '=' + value
              }
            }
          } else {
            if (text === 'time' && value !== '') {
              if (value === null) {
                this.$message({
                  type: 'error',
                  message: '请选择时间范围'
                })
                flag = false
              }
              search = '&startTime=' + value[0] + '&endTime=' + value[1]
            } else {
              if (value !== null && value !== '' && value !== undefined) {
                search += '&' + text + '=' + value
              }
            }
          }
        })
        if (flag) {
          window.location.href = '/rest/customer/feedback/feedbacks/form-list-file' + search
        }
      }
    }
  }
</script>

<style lang="scss">
  .infoListWrap.com-table{
    .el-table th,.el-table td{
      text-align: center;
    }
  }
</style>

<style lang="scss" scoped>
  .pageUrl{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .isRead{
    position: relative;
    top:5px;
    .unRead-icon{
      position: absolute;
      top:-5px;
      right:0;
    }
  }
  .el-icon-delete, .el-icon-s-comment{
    font-size: 18px;
    cursor: pointer;
  }
  .unRead-icon{
    width:8px;
    height: 8px;
    display: inline-block;
    background: #f00;
    border-radius: 50%;
  }
  .changeStatu{
    cursor: pointer;
    margin-left:5px;
    &.unRead{
      color:#409EFF;
    }
  }
  .el-popover__reference{
    display: inline-block;
    cursor: pointer;
  }
  .el-icon-delete{
    font-size: 18px;
    cursor: pointer;
  }
  .table-learn {
    margin-bottom: 10px;
    font-size: 14px;
    display: flex;
    // justify-content: space-between;
    a {
      cursor: pointer;
    }
  }
  .ms-list{
    position: relative;
    .operation{
      position: absolute;
      top:13px;
      right: 0px;
      z-index: 99;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/client/InfoList.vue